const EVENT_POINT_DELIVERY = 'event-point-delivery';

const pointDeliveryEventTrigger = () => {
	document.querySelectorAll('.js-delivery-type-selector-point').forEach(
      radio => {
        radio.addEventListener('change', () => {
          if (radio.checked) {
            const event = new CustomEvent(EVENT_POINT_DELIVERY);
            event.action = 'point_delivery';
		        document.dispatchEvent(event);
          }
        })
      });
};

export {EVENT_POINT_DELIVERY, pointDeliveryEventTrigger};